import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import { AlertMessage } from '../../hooks/alert';

interface AlertProps {
  data: AlertMessage;
}

const Alert: React.FC<AlertProps> = ({ data }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let color = '';
  switch (data.type) {
    case 'success':
      color = 'green';
      break;
    case 'error':
      color = '#ff2f43';
      break;
    default:
      color = '#000';
  }

  useEffect(() => {
    if (data.description) {
      handleShow();
    }
  }, [data]);

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title
            className="m-auto text-center"
            style={{
              color,
              width: '100%',
            }}
          >
            {data.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center" style={{ color }}>
          {data.description}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Alert;
